import { render, staticRenderFns } from "./ExcluirPedidoModal.vue?vue&type=template&id=74886766&"
import script from "./ExcluirPedidoModal.vue?vue&type=script&lang=js&"
export * from "./ExcluirPedidoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports